import React from "react";
import Classes from "classnames";

import FormFieldFormElementProto from "../../form-element-proto";
import FormSelect from 'core/gd-form/form-element/select-new/select-new';

class StringField extends FormFieldFormElementProto {

    constructor(props) {
        super(props);
    }

    onChange(newValue) {

        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    render() {

        let classes;

        classes = Classes('gd-form-field-dropdown','form-element',{
        });

        const options = this.props.field.params.listItems.map(item=>{
            return {
                label: item.value,
                value: item.id
            }
        });

        return (

            <div className={classes}>
                <FormSelect className="default-skin"
                        form={this.props.form} name={this.props.name}
                        placeholder="Please select"
                        size="big"
                        options={options}
                        />
            </div>

        );
    }

}

// StringField.propTypes = props;
// StringField.defaultProps = defaultProps;

export default function renderStringFormFieldFormElement(field, props) {
    return <StringField field={field} {...props} />;
}